import { apiClient, unwrap, unwrapPaginated } from './client';
import type { ContractType, Employee, EmployeeStatus } from '@/types';

export interface EmployeeQuery {
  department?:   string;
  status?:       EmployeeStatus;
  contractType?: ContractType;
  search?:       string;
  page?:         number;
  limit?:        number;
}

export interface CreateEmployeePayload {
  matricule:    string;
  fullName:     string;
  email?:       string;
  phone?:       string;
  department:   string;
  jobTitle:     string;
  contractType: ContractType;
  hireDate:     string;
  endDate?:     string;
  salaryCents?: number;
  currency?:    string;
  civilite?:      'M.' | 'Mme';
  dateNaissance?: string;
  lieuNaissance?: string;
  numeroCnps?:    string;
  situationFamiliale?:  'celibataire' | 'marie' | 'divorce' | 'veuf';
  enfantsACharge?:      number;
  categorieConvention?: string;
  soumisCnps?:          boolean;
  dateAnciennete?:      string;
  banqueNom?:           string;
  compteIntitule?:      string;
  compteNumero?:        string;
}

export interface UpdateEmployeePayload {
  department?:  string;
  jobTitle?:    string;
  phone?:       string;
  status?:      EmployeeStatus;
  salaryCents?: number;
  civilite?:      'M.' | 'Mme';
  dateNaissance?: string;
  lieuNaissance?: string;
  numeroCnps?:    string;
  situationFamiliale?:  'celibataire' | 'marie' | 'divorce' | 'veuf';
  enfantsACharge?:      number;
  categorieConvention?: string;
  soumisCnps?:          boolean;
  dateAnciennete?:      string;
  banqueNom?:           string;
  compteIntitule?:      string;
  compteNumero?:        string;
  endDate?:       string | null;
}

export const hrApi = {
  getEmployees: async (query: EmployeeQuery = {}) => {
    const res = await apiClient.get('/hr/employees', { params: query });
    return unwrapPaginated<Employee>(res);
  },

  getEmployee: async (id: string): Promise<Employee> => {
    const res = await apiClient.get(`/hr/employees/${id}`);
    return unwrap<Employee>(res);
  },

  createEmployee: async (payload: CreateEmployeePayload): Promise<Employee> => {
    const res = await apiClient.post('/hr/employees', payload);
    return unwrap<Employee>(res);
  },

  updateEmployee: async (id: string, payload: UpdateEmployeePayload): Promise<Employee> => {
    const res = await apiClient.patch(`/hr/employees/${id}`, payload);
    return unwrap<Employee>(res);
  },
};
